import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import AppErrorPage from '../../pages/errors/AppErrorPage';
import { normalizeAppError } from '../../errors/normalizeAppError';

export interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

/**
 * Catches uncaught render errors and shows the shared error page.
 */
export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[AppErrorBoundary]', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <AppErrorPage
          error={normalizeAppError(this.state.error, {
            kind: 'runtime',
            title: 'Application error',
          })}
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
